import { render, staticRenderFns } from "./CustomAttributeSelector.vue?vue&type=template&id=3120c087&scoped=true&"
import script from "./CustomAttributeSelector.vue?vue&type=script&lang=js&"
export * from "./CustomAttributeSelector.vue?vue&type=script&lang=js&"
import style0 from "./CustomAttributeSelector.vue?vue&type=style&index=0&id=3120c087&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3120c087",
  null
  
)

export default component.exports